import { toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "p-d-flex" }
const _hoisted_2 = {
  key: 0,
  class: "p-col-3"
}
const _hoisted_3 = { class: "p-field p-m-2" }
const _hoisted_4 = { class: "p-float-label" }
const _hoisted_5 = { class: "kn-material-input-label" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Column = _resolveComponent("Column")
  const _component_DataTable = _resolveComponent("DataTable")
  const _component_Button = _resolveComponent("Button")
  const _component_Toolbar = _resolveComponent("Toolbar")
  const _component_InputText = _resolveComponent("InputText")
  const _component_Dialog = _resolveComponent("Dialog")

  return (_openBlock(), _createBlock(_component_Dialog, {
    style: _ctx.previewDialogDescriptor.dialog.style,
    contentStyle: _ctx.previewDialogDescriptor.dialog.contentStyle,
    visible: true,
    modal: true,
    class: "p-fluid kn-dialog--toolbar--primary",
    header: _ctx.$t('kpi.measureDefinition.preview'),
    closable: false
  }, {
    footer: _withCtx(() => [
      _createVNode(_component_Button, {
        class: "kn-button kn-button--secondary",
        label: _ctx.$t('common.close'),
        onClick: _ctx.closeTemplate
      }, null, 8, ["label", "onClick"])
    ]),
    default: _withCtx(() => [
      _createVNode("div", _hoisted_1, [
        _createVNode(_component_DataTable, {
          value: _ctx.rows,
          class: "p-datatable-sm kn-table",
          dataKey: "id",
          responsiveLayout: "stack",
          breakpoint: "960px"
        }, {
          empty: _withCtx(() => [
            _createTextVNode(_toDisplayString(_ctx.$t('common.info.noDataFound')), 1)
          ]),
          default: _withCtx(() => [
            (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.columns, (col) => {
              return (_openBlock(), _createBlock(_component_Column, {
                class: "kn-truncated",
                field: col.name,
                header: col.label,
                key: col.field,
                sortable: true
              }, null, 8, ["field", "header"]))
            }), 128))
          ]),
          _: 1
        }, 8, ["value"]),
        (_ctx.rule.placeholders && _ctx.rule.placeholders.length > 0)
          ? (_openBlock(), _createBlock("div", _hoisted_2, [
              _createVNode(_component_Toolbar, { class: "kn-toolbar kn-toolbar--primary p-m-0" }, {
                start: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_ctx.$t('kpi.measureDefinition.filters')), 1)
                ]),
                end: _withCtx(() => [
                  _createVNode(_component_Button, {
                    class: "kn-button p-button-text p-button-rounded",
                    onClick: _ctx.loadPreview
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode(_toDisplayString(_ctx.$t('common.run')), 1)
                    ]),
                    _: 1
                  }, 8, ["onClick"])
                ]),
                _: 1
              }),
              _createVNode("div", null, [
                (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.rule.placeholders, (placeholder) => {
                  return (_openBlock(), _createBlock("div", {
                    key: placeholder.id
                  }, [
                    _createVNode("div", _hoisted_3, [
                      _createVNode("span", _hoisted_4, [
                        _createVNode(_component_InputText, {
                          class: "kn-material-input",
                          type: "text",
                          modelValue: placeholder.value,
                          "onUpdate:modelValue": ($event: any) => (placeholder.value = $event),
                          modelModifiers: { trim: true }
                        }, null, 8, ["modelValue", "onUpdate:modelValue"]),
                        _createVNode("label", _hoisted_5, _toDisplayString(placeholder.name), 1)
                      ])
                    ])
                  ]))
                }), 128))
              ])
            ]))
          : _createCommentVNode("", true)
      ])
    ]),
    _: 1
  }, 8, ["style", "contentStyle", "header"]))
}